import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';

export default function BarValue({ lang }) {
  const seoData = {
    en: {
      title: 'Bar Partnership - The 500€ Content Trade',
      description: 'Get professional content for your bar for free. Join the Barberà del Vallès Beer Pass network.'
    },
    es: {
      title: 'Asociación para Bares - El Intercambio de 500€',
      description: 'Consigue contenido profesional para tu bar gratis. Únete a la red de Barberà del Vallès Beer Pass.'
    }
  };

  const currentSeo = seoData[lang];

  const sections = [
    {
      id: 'get',
      title: lang === 'en' ? 'Section 1: What you get' : 'Sección 1: Lo que recibes',
      content: lang === 'en' 
        ? 'I shoot 3 professional Instagram Reels and 10 high-end photos for your bar. Usually costs 500€. You get it 100% free.'
        : 'Grabo 3 Reels profesionales y 10 fotos de alta calidad para las redes sociales de tu bar. Normalmente cuesta 500€. Lo obtienes 100% gratis.',
    },
    {
      id: 'give',
      title: lang === 'en' ? 'Section 2: What you give' : 'Sección 2: Lo que das',
      content: lang === 'en'
        ? 'You accept the Barberà Beer Pass. The customer buys the first beer. You give them the second beer free. Zero upfront cost. Zero risk.'
        : 'Aceptas el Barberà Beer Pass. El cliente compra la primera cerveza. Tú le das la segunda gratis. Cero coste inicial. Cero riesgo.',
    },
    {
      id: 'why',
      title: lang === 'en' ? 'Section 3: Why I do this' : 'Sección 3: Por qué hago esto',
      content: lang === 'en'
        ? 'I want to build my local video portfolio. You want to fill empty chairs on slow nights. We both win.'
        : 'Quiero ampliar mi portafolio de video local. Tú quieres llenar sillas vacías en las noches flojas. Ambos ganamos.',
    },
    {
      id: 'catch',
      title: lang === 'en' ? 'Section 4: The catch' : 'Sección 4: La trampa',
      content: lang === 'en'
        ? 'I am only partnering with 10 bars in Barberà. I have 3 spots left. Are you in?'
        : 'Solo me asociaré con 10 bares en Barberà. Me quedan 3 plazas. ¿Te apuntas?',
      urgent: true
    }
  ];

  return (
    <div className="flex flex-col items-center w-full min-h-screen bg-black text-white">
      <SEO title={currentSeo.title} description={currentSeo.description} lang={lang} />
      
      {/* Hero Section */}
      <section className="w-full pt-16 pb-20 border-b-8 border-white">
        <motion.h1 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-6xl sm:text-7xl md:text-8xl font-black uppercase leading-[0.85] tracking-tighter"
        >
          {lang === 'en' ? 'The 500€' : 'El Intercambio'} <br />
          <span className="text-amber-400">
            {lang === 'en' ? 'Content Trade' : 'de Contenido de 500€'}
          </span>
        </motion.h1>
      </section>

      {/* Content Sections */}
      <div className="w-full flex flex-col">
        {sections.map((section, index) => (
          <motion.section 
            key={section.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            className={`py-16 border-b-4 border-zinc-800 ${section.urgent ? 'bg-red-600 -mx-4 px-4 sm:-mx-6 sm:px-6' : ''}`}
          >
            <h2 className={`text-2xl sm:text-3xl font-black uppercase mb-6 ${section.urgent ? 'text-black bg-white inline-block px-2' : 'text-amber-400'}`}>
              {section.title}
            </h2>
            <p className={`text-3xl sm:text-5xl font-black uppercase leading-[1.1] tracking-tight max-w-4xl ${section.urgent ? 'text-white' : 'text-white'}`}>
              {section.content}
            </p>
          </motion.section>
        ))}
      </div>

      {/* Massive CTA Section */}
      <section className="w-full py-24 flex flex-col items-center">
        <motion.div 
          whileHover={{ scale: 1.02, rotate: -1 }}
          whileTap={{ scale: 0.98 }}
          className="w-full"
        >
          <a 
            href="mailto:contact@barberadelvalles.beer?subject=I'm%20In%20-%20Bar%20Partnership" 
            className="block w-full text-center bg-amber-400 text-black font-black text-5xl sm:text-7xl md:text-8xl py-12 px-4 border-4 border-white shadow-[12px_12px_0_0_#ffffff] hover:shadow-[4px_4px_0_0_#ffffff] transition-all uppercase leading-none"
          >
            {lang === 'en' ? "I'M IN" : 'ME APUNTO'}
          </a>
        </motion.div>
        
        <p className="mt-12 text-zinc-500 font-black uppercase tracking-[0.2em] text-sm sm:text-base">
          {lang === 'en' ? 'Strictly limited to 10 bars total.' : 'Estrictamente limitado a 10 bares en total.'}
        </p>
      </section>
    </div>
  );
}